import React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	BLACKS_AND_WHITES,
	getTimeDurationFromSeconds,
	STOPLIGHT_COLORS,
} from '../../utils/DataFormatterUtils';
import { Card, Col, Divider, Row } from 'antd';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import { DetailsDisplay } from '../details_display/DetailsDisplay';

require('./InvoicePageDisplay.less');

const SimpleLineItemsDisplay = ({ invoice, lineItemFieldName, currency }) => {
	return nullSafeGetOrElse(lineItemFieldName, invoice, []).map((mli, idx) => (
		<div
			key={`${lineItemFieldName}-${idx}`}
			className="sectionHeaderWrapper2"
			style={{
				marginBottom: idx === nullSafeGetOrElse(lineItemFieldName, invoice, []).length - 1 ? 16 : 8,
			}}
		>
			<span className="lineItemDetailText">{mli.description}</span>
			<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
		</div>
	));
};

export default function InvoiceDetailsDisplay({
	invoice = {},
	lastInvoice = {},
	displayComparison = false,
	currency,
}) {
	return (
		<Col>
			<DetailsDisplay
				title={'Labor'}
				fieldName={'laborTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('laborLineItems', invoice, []).map((lli, idx) => (
				<div
					key={`laborLineItems-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{lli.numberOfTech} {lli.roleType} * {getTimeDurationFromSeconds(lli.seconds)} @{' '}
						{currency.format(parseFloat(lli.hourlyRate))} / hour
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Materials'}
				fieldName={'materialTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('materialLineItems', invoice, []).map((mli, idx) => (
				<div
					key={`materialLi-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{mli.quantity} {mli.unitType} of {mli.description}
						{mli.partNumber ? ` (${mli.partNumber})` : null} @{' '}
						{currency.format(parseFloat(mli.unitPrice))} / {mli.unitType}
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Travel'}
				fieldName={'travelTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="travelLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Freight'}
				fieldName={'freightTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="freightLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Miscellaneous'}
				fieldName={'miscTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				invoice={invoice}
				lineItemFieldName="miscLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Total Before Tax'}
				fieldName={'invoiceTotalBeforeTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<Divider />
			<DetailsDisplay
				title={'Tax'}
				fieldName={'invoiceTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('taxLineItems', invoice, []).map((lli, idx) => (
				<div
					key={`taxLineItems-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('taxLineItems', invoice, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">{lli.taxType}</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Total After Tax'}
				fieldName={'invoiceTotalAfterTax'}
				record={invoice}
				lastRecord={lastInvoice}
				currency={currency}
				displayComparison={displayComparison}
			/>
		</Col>
	);
}
